export default __webpack_public_path__ + "static/media/copy_white.defb56e1.svg";